import React from "react";

import { Typography } from "components";

type NumberedSectionHeaderProps = {
  number: string;
  title: string;
  supporting?: string;
};

export const NumberedSectionHeader = ({ number, title, supporting }: NumberedSectionHeaderProps) => (
  <div className="pdf-section-header">
    <div className="pdf-section-header-title-row">
      <span className="pdf-section-number">{number}</span>
      <Typography variant="h3" className="pdf-section-title">
        {title}
      </Typography>
    </div>
    {supporting && (
      <Typography variant="paragraph-s" className="pdf-section-supporting">
        {supporting}
      </Typography>
    )}
  </div>
);
